import { render, staticRenderFns } from "./CConfirmDialog.vue?vue&type=template&id=2ece2571"
import script from "./CConfirmDialog.vue?vue&type=script&lang=js"
export * from "./CConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports